export function isVerifyEmailCodeSuccess(response) {
  if (response === true) {
    return true
  }

  if (typeof response === 'string') {
    return response.toLowerCase() === 'true'
  }

  const value = response?.value

  if (value === true) {
    return true
  }

  if (typeof value === 'string' && value.toLowerCase() === 'true') {
    return true
  }

  if (value === false) {
    return false
  }

  if (typeof value === 'string' && value.toLowerCase() === 'false') {
    return false
  }

  return Boolean(response)
}
